import { boAPI } from 'constants/api';
import fetchApi from 'services/fetch';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const initialState = {
  dates: [],
  appointment: {},
  formData: {},
};

export const scheduleVisit = {
  state: { ...initialState },
  reducers: {
    updateAppointmentData(state, payload) {
      return {
        ...state,
        appointment: payload,
      };
    },
    updateDate(state, payload) {
      return {
        ...state,
        dates: payload,
      };
    },
    updateFormData(state, payload) {
      return {
        ...state,
        formData: payload,
      };
    },
    clearSchedule() {
      return { ...initialState };
    },
  },
  effects: (dispatch) => {
    return {
      async getAppointment({ onGetApointment, contractId, onError }) {
        this.updateDate([]);
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: 'GET',
          url: boAPI.getAppointment.replace('{contractId}', contractId),
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            this.updateAppointmentData(response?.data);
            if (onGetApointment) onGetApointment(response?.data);
          })
          .catch((error) => {
            dispatch.apiStatus.setProcessing(false);
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Get Appointment',
                boAPI.getAppointment.replace('{contractId}', contractId),
                'Get Appointment API'
              ),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Appointment API'),
            });
            if (onError) onError();
          });
      },
      async getTimeSlot(params) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: 'GET',
          url: `${boAPI.getTimeSlots}${params?.contractId}/appointment/${params?.appointmentId}/${params?.subappointmentID}/searchTimeSlot?startDateTime=${params?.startDateTime}&endDateTime=${params?.endDateTime}`,
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            this.updateDate(response?.data?.availableTimeslots);
          })
          .catch((error) => {
            dispatch.apiStatus.setProcessing(false);
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Schedule Visit',
                `${boAPI.getTimeSlots}${params?.contractId}/appointment/${params?.appointmentId}/${params?.subappointmentID}/searchTimeSlot?startDateTime=${params?.startDateTime}&endDateTime=${params?.endDateTime}`,
                'Get Available Schedule API'
              ),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Available Schedule API'),
            });
          });
      },

      async updateAppointment({ params, onSuccess }) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: 'PATCH',
          url: `${boAPI.getTimeSlots}${params?.contractId}/appointment/${params?.appointmentId}/${params?.subappointmentID}?startDateTime=${params?.startDateTime}&endDateTime=${params?.endDateTime}`,
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            if (onSuccess) onSuccess();
          })
          .catch((error) => {
            dispatch.apiStatus.setProcessing(false);
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Update Schedule',
                `${boAPI.getTimeSlots}${params?.contractId}/appointment/${params?.appointmentId}/${params?.subappointmentID}?startDateTime=${params?.startDateTime}&endDateTime=${params?.endDateTime}`,
                'Update Schedule API'
              ),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(error, ACTIVATION, 'Update Schedule API'),
            });
          });
      },
      async scheduleQueue({ payload }) {
        dispatch.apiStatus.setProcessing(true);
        track('Schedule New Visit loaded', {});
        return fetchApi({
          method: 'POST',
          url: boAPI.scheduleQueue,
          data: { ...payload },
        })
          .then((response) => {
            dispatch.apiStatus.setRequestFailed({
              errorCode: 200,
              message: 'Tuvimos un problema agendando tu fecha de installación',
            });
            if (response?.data?.addedToTheQueue) {
              track('Schedule New Visit Submitted', {});
            }
            return Promise.resolve({ success: true, response: response?.data });
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({
              ...error,
              message: 'Tuvimos un problema agendando tu fecha de installación',
            });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(error, ACTIVATION, 'Schedule API', boAPI.scheduleQueue, 'Schedule API'),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(error, ACTIVATION, 'Schedule API'),
            });
            return Promise.resolve({ success: false, response: error });
          });
      },
    };
  },
};
